export default __webpack_public_path__ + "static/project-slide-5-4032-2268-9f57711f7eb7a9302a82b4503f76d3a4.webp";